import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const digitalWorkFlowSlice = createSlice({
  name: 'digitalWorkFlow',
  initialState: {
    sharedToken:'',
    taxID:''
   
  },
  reducers: {
    
    setSharedTokenRedux: (state, action) => {
        const { sharedToken } = action.payload
        state.sharedToken = sharedToken
      },
      setTaxIDRedux: (state, action) => {
        const { taxID } = action.payload
        state.taxID = taxID
      }
      
  },
})

export default digitalWorkFlowSlice.reducer;

export const {
    setSharedTokenRedux,
    setTaxIDRedux
   
  
} = digitalWorkFlowSlice.actions

export const getSharedTokenRedux = (state) => state.digitalWorkFlow.sharedToken
export const getTaxIDRedux = (state) => state.digitalWorkFlow.taxID



